module.exports = __webpack_public_path__ + "media/music/0b18f02669375ad2ee80bef8d07ea7ec.mp3";